Performance = require './metrics/performance'

module.exports =
  init: ->
    new Performance().pageReady()
